import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { CTAButton } from './CTAButton';
export function FinalClose() {
  return <section className="bg-parchment pt-20 pb-32 px-6 md:px-8 text-center" data-id="element-40">
      <div className="max-w-2xl mx-auto" data-id="element-41">
        <AnimatedSection data-id="element-42">
          <p className="text-xl md:text-2xl font-serif text-bark mb-8 leading-relaxed" data-id="element-43">
            No necesitás convertirte en otra persona para rezar.
          </p>

          <p className="text-xl md:text-2xl font-serif text-bark mb-8 leading-relaxed" data-id="element-44">
            Necesitás una regla pequeña que te sostenga cuando vos no te
            sostenés.
          </p>

          <p className="text-lg text-bark/80 mb-12" data-id="element-45">
            Si hoy estás cansada, dispersa, con culpa… <br data-id="element-46" />
            empezá igual.
          </p>

          <p className="text-lg text-bark/80 mb-4" data-id="element-47">
            Mañana no se arregla solo.
          </p>

          <p className="text-3xl md:text-4xl font-serif font-bold text-wine mb-12" data-id="element-48">
            7 minutos. Hoy.
          </p>

          <CTAButton data-id="element-49">Quiero el plan</CTAButton>

          <div className="mt-24 pt-8 border-t border-bark/10" data-id="element-50">
            <p className="text-sm text-bark/40 font-serif italic" data-id="element-51">
              Devoción sin Culpa © 2024
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}